import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { getLang } from "../../state/reducers/langSession";
import { saveState } from "../../state/utils/localStorage";

export const InvitationExpired = ({ invitationLangData }) => {
  const { loginWithRedirect } = useAuth0();
  const language = getLang();

  return (
    <div className="lg:tw-max-w-[400px] lg:tw-mx-auto lg:tw-border-[#C2C8D0]/30 lg:tw-border lg:tw-border-solid lg:tw-rounded-md lg:tw-mt-[64px] tw-px-[40px] tw-py-[44px] tw-flex tw-flex-col tw-gap-[24px]">
      <div className="tw-flex tw-flex-col tw-gap-[36px]">
        <h1 className="tw-text-center !tw-font-bold tw-text-[22px] tw-leading-[32px] !tw-text-[#3E3A39] !tw-font-ayana !tw-m-0">
          {invitationLangData.title}
        </h1>
        <p className="tw-text-[14px] tw-leading-[22px] !tw-font-ayana !tw-text-[#3E3A39] !tw-m-0">
          {invitationLangData.description}
        </p>
      </div>
      <ul className="!tw-m-0 tw-pl-[20px]">
        {invitationLangData.stepsToFollow.map((step) => (
          <li className="tw-text-[14px] tw-leading-[22px] !tw-font-ayana !tw-text-[#3E3A39] !tw-m-0 tw-list-decimal">
            {step}
          </li>
        ))}
      </ul>
      <button
        onClick={() => {
          const href = `${window.location.pathname}${window.location.search}`;
          saveState("redirectUrl", href);
          loginWithRedirect({
            authorizationParams: {
              ui_locales: language === "zh" ? "zh-CN" : language,
              redirect_uri:
                language === "en"
                  ? `${window.location.origin}/callback`
                  : `${window.location.origin}/${language}/callback`,
            },
            appState: { targetUrl: "redirectUrl" },
          });
        }}
        className="tw-w-full tw-bg-black tw-p-4 tw-rounded-md tw-text-base tw-leading-[20px] tw-font-bold tw-text-white tw-cursor-pointer !tw-font-ayana">
        {invitationLangData.cta}
      </button>
      <p className="tw-text-[12px] tw-leading-[22px] !tw-font-ayana !tw-text-[#3E3A39] !tw-m-0">
        {invitationLangData.assistance_contact}
      </p>
    </div>
  );
};
